import React, {useState} from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import CopyServicePricesStore from "./CopyServicePricesStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./CopyServicePricesButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Checkbox from "../../../ui_components/Checkbox/Checkbox";
import FilterInput from "../../Inputs/FilterInput/FilterInput";
import MessageCard from "../../../ui_components/MessageCard/MessageCard";
import InboxIcon from '@mui/icons-material/Inbox';
import Alert from "../../../ui_components/Alert/Alert";
import AlertType from "../../../ui_components/Alert/AlertType";
import CopyServicePricesButtonProperties from './CopyServicePricesButtonProperties';

const CopyServicePricesButton: React.FC<CopyServicePricesButtonProperties> = ({
                                                                  onClick = () => {
                                                                  },
                                                                  onSave = () => {
                                                                  },
                                                                  showIcon = true,
                                                                  showText = true,
                                                                  disabled,
                                                                  className = '',
                                                                  sourceSalePriceId,
                                                                  serviceName,
                                                                  rounded = false,
                                                                  size = ButtonSize.DEFAULT,
                                                                  type = ButtonType.DEFAULT
                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const store = new CopyServicePricesStore(commonContext, sourceSalePriceId, serviceName);

    const [filter, setFilter] = useState('');

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        setFilter('');
        store.closeModal();
    }

    const onCopySave = async () => {
        if (!store.enableButton) {
            return;
        }
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            if (onSave) {
                onSave();
            }
        }
    }

    const text = 'Copiar valores';
    const btnIcon = <ContentCopyIcon/>;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => {
            const filteredTargets = store.targetSalePrices.filter(t =>
                t.name.toLowerCase().includes(filter.toLowerCase())
            );
            const filteredTargetIds = filteredTargets.map(t => t.id);
            const allFilteredSelected = filteredTargetIds.length > 0
                && filteredTargetIds.every(id => store.selectedTargetIds.includes(id));
            return (
                <>
                    <Modal fullScreen={false} loading={store.loading} title={text}
                        onClose={onCloseModal} open={store.isModalOpen}>
                        <div className={classes.modal_container}>
                            <Alert
                                className={classes.hint}
                                type={AlertType.WARNING}
                                text={'Los valores del servicio seleccionado en las listas de destino serán eliminados y sustituidos exactamente por los valores de esta lista.'}
                            />
                            <FilterInput
                                value={filter}
                                placeholder={'Buscar lista de precios'}
                                onChange={setFilter}
                                fullWidth
                                className={classes.filter_container}
                            />
                            {filteredTargets.length > 0 &&
                            <div className={classes.select_all_container}>
                                <Checkbox
                                    className={classes.select_all_checkbox}
                                    text={'Seleccionar todo'}
                                    selected={allFilteredSelected}
                                    onChange={(checked) => store.toggleTargets(filteredTargetIds, checked)}
                                />
                            </div>}
                            <div className={classes.targets_container}>
                                {filteredTargets.map(salePrice => (
                                    <Checkbox
                                        key={salePrice.id}
                                        className={classes.target_checkbox}
                                        text={salePrice.name}
                                        selected={store.selectedTargetIds.includes(salePrice.id)}
                                        onChange={(checked) => store.toggleTarget(salePrice.id, checked)}
                                    />
                                ))}
                                {filteredTargets.length === 0 &&
                                <MessageCard icon={InboxIcon} title={'Sin listas de precios disponibles'}/>}
                            </div>
                            <div className={classes.actions_container}>
                                <Button
                                    className={classes.cancel_btn} onClick={onCloseModal}
                                    type={ButtonType.DEFAULT}
                                    text={i18n.translate("CANCEL")}/>
                                <Button
                                    disabled={!store.enableButton}
                                    loading={store.loading} className={classes.input} onClick={onCopySave}
                                    type={ButtonType.SECONDARY}
                                    text={i18n.translate("SAVE")}/>
                            </div>
                        </div>
                    </Modal>
                    <Btn/>
                </>
            );
        }}
    </Observer>
}

export default CopyServicePricesButton;
